<template>
  <div class="app-body">
    <Header></Header>
    <main class="container-fluid">
      <div class="col-sm-12 col-md-6 offset-md-3 col-text">
        <h1>Beta Testing</h1>
        <p>GanttProject Cloud is currently in beta testing. We are working on the final bits of its functionality and
          service monitoring.</p>

        <p>We invited a few users to the private beta and they are free to invite their colleagues. We do not charge for
          usage during private beta testing, provided that the usage is reasonable. However, we start charging as soon
          as we launch to the public.</p>

      </div>
    </main>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import Header from '@/components/Header.vue';

@Component({
  components: {Header}
})
export default class AboutPrivateBeta extends Vue {
}
</script>

<style lang="scss">
@import 'sass/about_private_beta';
</style>
